import React, { useState } from "react";
import { Stage, Layer, Line, Text, Circle, Arrow } from "react-konva";
import "./Cfg.css";

export default function Cfg(props) {
  const [configStates] = useState({
    defaults: {
      strokeWidth: 1,
      stroke: "#000000",
      fill: "#eae9e9",
      fontSize: 11,
    },
  });

  if (!props.oneState) {
    return (
      <div className="CfgDraw">
        <Stage width={300} height={150 + props.heigth * 11}>
          <Layer>
            <Line
              points={[20, 20, 30, 30, 20, 40]}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Arrow
              points={[157, 50, 150, 70, 160, 85, 170, 70, 163, 50]}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
              tension={0.54}
              fill={configStates.defaults.fill}
            />
            <Arrow
              points={[70, 30, 140, 30]}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
              fill={configStates.defaults.fill}
            />
            <Circle
              x={50}
              y={30}
              Radius={20}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Circle
              x={160}
              y={30}
              Radius={20}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Circle
              x={160}
              y={30}
              Radius={17}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Text text="q0" x={44} y={25} />
            <Text text="q1" x={154} y={25} />
            <Text
              text={props.sText}
              x={60}
              y={48}
              fontSize={configStates.defaults.fontSize}
            />
            <Text
              text={props.finalText}
              x={147}
              y={88}
              fontSize={configStates.defaults.fontSize}
            />
          </Layer>
        </Stage>
      </div>
    );
  } else {
    return (
      <div className="CfgDraw">
        <Stage width={300} height={150 + props.heigth * 11}>
          <Layer>
            <Line
              points={[20, 20, 30, 30, 20, 40]}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Arrow
              points={[70, 30, 140, 30]}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
              fill={configStates.defaults.fill}
            />
            <Circle
              x={50}
              y={30}
              Radius={20}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Circle
              x={160}
              y={30}
              Radius={20}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Circle
              x={160}
              y={30}
              Radius={17}
              fill={configStates.defaults.fill}
              stroke={configStates.defaults.stroke}
              strokeWidth={configStates.defaults.strokeWidth}
            />
            <Text text="q0" x={44} y={25} />
            <Text text="q1" x={154} y={25} />
            <Text
              text={props.sText}
              x={70}
              y={48}
              fontSize={configStates.defaults.fontSize}
            />
          </Layer>
        </Stage>
      </div>
    );
  }
}
